<jni-move-to-freight
  [(display)]="display"
  [brandingConsultantID]="freightsParams.BrandingConsultantID ?? ''"
  [freightSelected]="frieghtsSelected"
  (moveToFreightEvent)="moveToFreightEvent($event)"
  *ngIf="display"></jni-move-to-freight>
<div
  class="d-flex justify-content-between align-items-center globalborder-btm-header pb-3 pt-2 px-3">
  <h2 class="mb-0">Freight Charges</h2>
  <div class="bcledger-panel d-flex justify-content-between ms-2 me-auto">
    <div class="lds-ring inline me-auto ms-2" *ngIf="false">
      <jni-spinner />
    </div>
  </div>
  <div class="user-panel col-auto d-flex justify-content-between">
    <div class="d-flex align-items-center gap-3">
      <p-button label="Clear Filters" (click)="clearTable(dt)" />

      <p-button
        label="Export Excel"
        variant="outlined"
        icon="pi pi-cloud-upload"
        severity="secondary"
        (click)="exportExcelFile()"
        class="fullwdth secondary-btn" />

      <span class="cross-border" (click)="onCloseModalEvent()"
        ><i class="pi pi-times"></i
      ></span>
    </div>
  </div>
</div>

<p-table
  #dt
  stripedRows
  [scrollable]="true"
  scrollHeight="calc(100vh - 260px)"
  [size]="'small'"
  [resizableColumns]="true"
  [value]="freightLists"
  styleClass="p-datatable-customers table-listing p-head-pad"
  [rowHover]="true"
  [rows]="20"
  [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[10, 20, 50, 1000]"
  [paginator]="freightLists.length >= 20"
  selectionMode="single"
  [(selection)]="frieghtsSelected">
  <ng-template pTemplate="caption">
    <div class="d-flex align-items-center">
      <ng-container *ngIf="freightLists?.length">
        <div
          class="form-group has-float-label me-2 d-flex align-items-center gap-2">
          <label class="form-label" for="total">Total</label>
          <input
            jniAutoCompleteBlocker
            pInputText
            type="text"
            [value]="total"
            disabled
            *ngIf="total" />
        </div>
        <p-button
          (onClick)="moveToFreight()"
          *ngIf="frieghtsSelected?.RecID"
          [label]="'Move to freight'" />
      </ng-container>
    </div>
  </ng-template>

  <ng-template pTemplate="header">
    <tr>
      <th style="width: 6rem" pSortableColumn="Date">
        Date <p-sortIcon field="Date"></p-sortIcon>
        <p-columnFilter
          type="date"
          field="Date"
          display="menu"
          [hideOnClear]="true"
          [showMenu]="showfilter"></p-columnFilter>
      </th>
      <th pSortableColumn="ProjectName">
        Project name <p-sortIcon field="ProjectName"></p-sortIcon>
        <p-columnFilter
          type="text"
          field="ProjectName"
          display="menu"
          [hideOnClear]="true"
          [showMenu]="showfilter"></p-columnFilter>
      </th>
      <th pSortableColumn="AmountinTransactionCurrency">
        Amount in transaction
        <p-sortIcon field="AmountinTransactionCurrency"></p-sortIcon>
        <p-columnFilter
          type="numeric"
          field="AmountinTransactionCurrency"
          display="menu"
          [hideOnClear]="true"
          [showMenu]="showfilter"></p-columnFilter>
      </th>
      <th pSortableColumn="TrackingNumber">
        Tracking number <p-sortIcon field="TrackingNumber"></p-sortIcon>
        <p-columnFilter
          type="text"
          field="TrackingNumber"
          display="menu"
          [hideOnClear]="true"
          [showMenu]="showfilter"></p-columnFilter>
      </th>

      <th pSortableColumn="MovedToFreightSalesID">
        Moved to freight sales ID
        <p-sortIcon field="MovedToFreightSalesID"></p-sortIcon>
        <p-columnFilter
          type="text"
          field="MovedToFreightSalesID"
          display="menu"
          [hideOnClear]="true"
          [showMenu]="showfilter"></p-columnFilter>
      </th>

      <th pSortableColumn="ShipperName">
        Shipper name <p-sortIcon field="ShipperName"></p-sortIcon>
        <p-columnFilter
          type="text"
          field="ShipperName"
          display="menu"
          [hideOnClear]="true"
          [showMenu]="showfilter"></p-columnFilter>
      </th>
      <th pSortableColumn="ShipFromAddress">
        Ship from address <p-sortIcon field="ShipFromAddress"></p-sortIcon>
        <p-columnFilter
          type="text"
          field="ShipFromAddress"
          display="menu"
          [hideOnClear]="true"
          [showMenu]="showfilter"></p-columnFilter>
      </th>
      <th pSortableColumn="RecipientCompanyName">
        Recipient company <p-sortIcon field="RecipientCompanyName"></p-sortIcon>
        <p-columnFilter
          type="text"
          field="RecipientCompanyName"
          display="menu"
          [hideOnClear]="true"
          [showMenu]="showfilter"></p-columnFilter>
      </th>
      <th pSortableColumn="ShipToAddress">
        Ship to address <p-sortIcon field="ShipToAddress"></p-sortIcon>
        <p-columnFilter
          type="text"
          field="ShipToAddress"
          display="menu"
          [hideOnClear]="true"
          [showMenu]="showfilter"></p-columnFilter>
      </th>
      <th pSortableColumn="Carrier">
        Carrier <p-sortIcon field="Carrier"></p-sortIcon>
        <p-columnFilter
          type="text"
          field="Carrier"
          display="menu"
          [hideOnClear]="true"
          [showMenu]="showfilter"></p-columnFilter>
      </th>
      <th pSortableColumn="DeliveryMode">
        Mode of delivery <p-sortIcon field="DeliveryMode"></p-sortIcon>
        <p-columnFilter
          type="text"
          field="DeliveryMode"
          display="menu"
          [hideOnClear]="true"
          [showMenu]="showfilter"></p-columnFilter>
      </th>
      <th pSortableColumn="Description">
        Description
        <p-sortIcon field="Description"></p-sortIcon>
        <p-columnFilter
          type="text"
          field="Description"
          display="menu"
          [hideOnClear]="true"
          [showMenu]="showfilter"></p-columnFilter>
      </th>
      <th pSortableColumn="CreatedDateTime">
        Created date and time
        <p-sortIcon field="CreatedDateTime"></p-sortIcon>
        <p-columnFilter
          type="date"
          field="CreatedDateTime"
          display="menu"
          [hideOnClear]="true"
          [showMenu]="showfilter"></p-columnFilter>
      </th>
      <th pSortableColumn="CreatedBy">
        Created by <p-sortIcon field="CreatedBy"></p-sortIcon>
        <p-columnFilter
          type="text"
          field="CreatedBy"
          display="menu"
          [hideOnClear]="true"
          [showMenu]="showfilter"></p-columnFilter>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-freightList let-rowIndex="rowIndex">
    <tr
      class="p-selectable-row"
      [pSelectableRow]="freightList"
      [pSelectableRowIndex]="rowIndex">
      <td>{{ freightList.Date | date: "MM-dd-yyyy" }}</td>
      <td>{{ freightList.ProjectName }}</td>
      <td class="align-right">
        {{ freightList.AmountinTransactionCurrency | number: "1.2-2" }}
      </td>
      <td>
        <a
          class="link"
          (click)="redirectToTrackingSummary(freightList.TrackingNumber)"
          >{{ freightList.TrackingNumber }}</a
        >
      </td>
      <td>{{ freightList.MovedToFreightSalesID }}</td>
      <td>{{ freightList.ShipperName }}</td>
      <td>{{ freightList.ShipFromAddress }}</td>
      <td>{{ freightList.RecipientCompanyName }}</td>
      <td>{{ freightList.ShipToAddress }}</td>
      <td>{{ freightList.Carrier }}</td>
      <td>{{ freightList.DeliveryMode }}</td>

      <td>{{ freightList.Description }}</td>
      <td>
        <span *ngIf="freightList?.CreatedDateTime | hidedynamicsdate">
          {{ freightList.CreatedDateTime | date: "MM-dd-yyyy" }}
        </span>
      </td>
      <td>{{ freightList.CreatedBy }}</td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="20">No freight charges found.</td>
    </tr>
  </ng-template>
</p-table>

<jni-modal-stacker
  class="modal-header-sticky"
  *ngIf="trackingDisplayModal"
  [displayModal]="trackingDisplayModal"
  (closeEvent)="closeModalOnTrackingPage()">
  <h1 class="panelHeading">Freight Details</h1>
  <div class="panelBody">
    <jni-freight-details
      [isModal]="true"
      [trackingNumber]="trackingNumber"
      (scrollHiddenStatus)="scrollHiddenStatus()"
      (closeEvent)="closeModalFregihtDetails()"></jni-freight-details>
  </div>
</jni-modal-stacker>
